/**
 * Generated by scripts/design-system/regenerate-design-system.cjs.
 * Source spec hash: 78845d9823ce36a32892311299ebe1fa074d4c9117385c11d20ef109d99c9931
 */
import {
  base_colorContentBorder,
  white100,
} from 'ext-ui/style/colors'
import {
  nav_desktop_navContainerItemsVSpacing,
  nav_desktop_navContainerVSpacing,
} from 'ext-ui/style/spacing'
import { css } from 'styled-components'

export default css`
  background: ${white100};
  border-right-color: ${base_colorContentBorder};
  border-right-style: solid;
  border-right-width: 1px;
  display: flex;
  flex-direction: column;
  gap: ${nav_desktop_navContainerItemsVSpacing};
  height: 100%;
  padding-block: ${nav_desktop_navContainerVSpacing};
  transition: width 300ms cubic-bezier(0, 0, 0.58, 1);

  @media (prefers-reduced-motion: reduce) {
    transition: none;
  }

  &.not-minimized {
    align-items: flex-start;
    width: 232px;
  }

  &.minimized {
    align-items: center;
    width: 40px;
  }
`
